<template>
  <div>
    <v-card class="pa-3">
      <v-layout wrap>
        <v-flex xs12 class="text-xs-right">
          <v-btn @click="$emit('close')" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <template>
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 sm6 style="border-right: 1px solid #eee">
            <div style="position: relative" class="text-xs-center">
              <v-btn
                style="z-index: 3; position: absolute; right: 0px; top: 0px"
                small
                @click="showImage(input.identityNumberImage)"
              >
                <v-icon>visibility</v-icon>
              </v-btn>
              <img
                v-if="input.identityNumberImage"
                :src="input.identityNumberImage"
                style="height: auto; max-width: 100%; max-height: 500px"
              />
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <div class="px-4 pb-3">
              <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">ดูข้อมูล</div>
              <div class="form-control">
                <v-layout class="pa-0 ma-0" wrap row>
                  <v-flex xs6 sm6 class="form-control pa-1">
                    <label>{{ $t('รหัสสมาชิก') }}</label>
                    <input
                      readonly
                      v-model="input.memberId"
                      class="form-control"
                      type="text"
                      name="memberId"
                    />
                  </v-flex>
                  <v-flex xs6 sm6 class="form-control pa-1">
                    <label>{{ $t('Tier') }}</label>
                    <input
                      readonly
                      v-model="input.tier"
                      class="form-control"
                      type="text"
                      name="tier"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 class="form-control pa-1">
                    <label>{{ $t('ชื่อจริง') }}</label>
                    <input
                      v-model="input.firstName"
                      class="form-control"
                      type="text"
                      name="firstName"
                      readonly
                    />
                  </v-flex>
                  <v-flex xs12 sm6 class="form-control pa-1">
                    <label>{{ $t('นามสกุล') }}</label>
                    <input
                      readonly
                      v-model="input.lastName"
                      class="form-control"
                      type="text"
                      name="lastName"
                    />
                  </v-flex>
                  <v-flex xs6 sm6 class="form-control pa-1">
                    <label>{{ $t('วันเดือนปี เกิด') }}</label>
                    <input
                      readonly
                      :value="getdate(input.dob)"
                      class="form-control"
                      type="text"
                      name="dob"
                    />
                  </v-flex>
                  <v-flex xs6 sm6 class="form-control pa-1">
                    <label>{{ $t('อาชีพ') }}</label>
                    <input
                      readonly
                      v-model="input.job"
                      class="form-control"
                      type="text"
                      name="job"
                    />
                  </v-flex>
                  <v-flex
                    xs6
                    sm6
                    class="form-control pa-1"
                    :class="{ 'has-error': errors.has('identityNumber') }"
                  >
                    <label>{{ $t('เลขบัตรประชาชน') }}</label>
                    <input
                      readonly
                      :data-vv-as="$t('เลขบัตรประชาชน')"
                      v-validate="'required'"
                      v-model="input.identityNumber"
                      class="form-control"
                      type="text"
                      name="identityNumber"
                    />
                    <span class="text-error" v-if="errors.has('identityNumber')">{{
                      errors.first('identityNumber')
                    }}</span>
                  </v-flex>
                  <v-flex xs6 sm6 class="form-control pa-1">
                    <label>{{ $t('ไลน์') }}</label>
                    <input
                      readonly
                      v-model="input.lineName"
                      class="form-control"
                      type="text"
                      name="lineName"
                    />
                  </v-flex>
                  <v-flex xs6 sm6 class="form-control pa-1">
                    <label>{{ $t('ห้าง') }}</label>
                    <input
                      readonly
                      v-model="input.departmentStore"
                      class="form-control"
                      type="text"
                      name="departmentStore"
                    />
                  </v-flex>
                  <v-flex
                    xs6
                    sm6
                    class="form-control pa-1"
                    :class="{ 'has-error': errors.has('branch') }"
                  >
                    <label>{{ $t('สาขา') }}</label>
                    <input
                      readonly
                      v-model="input.branch"
                      class="form-control"
                      type="text"
                      name="branch"
                    />
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </template>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import PhotoViewer from 'photoviewer'
import uploadfile from '@/components/elements/uploadfile.vue'
import RedeemPointHistory from './RedeemPointHistory'

export default {
  props: ['value'],
  components: {
    DatePickerWithoutButton,
    uploadfile,
    RedeemPointHistory
  },
  data() {
    return {
      saveloading: false,
      input: {
        firstName: '',
        lastName: '',
        dob: '',
        job: '',
        identityNumber: '',
        identityNumberImage: '',
        lineName: ''
      },
      member_status: false,
      currentTab: 'info',
      showEditHistory: false,
      loadingBlock: false,
      loadingDelete: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.$set(this, 'input', {
      firstName: this.value.first_name,
      lastName: this.value.last_name,
      dob: this.value.dob,
      job: this.value.job,
      identityNumber: this.value.identity_number,
      identityNumberImage: this.value.identity_number_image,
      lineName: this.value.linename,
      memberId: this.value.toa_member_id,
      tier: this.value.tier,
      departmentStore: this.value.member_department_store,
      branch: this.value.member_branch
    })
    this.$nextTick(() => {
      this.member_status = this.value.member_status === 'true' ? true : false
    })
    this.$forceUpdate()

    // }
  },
  methods: {
    showImage(item) {
      var items = [
        {
          src: item,
          title: `${item}`
        }
      ]

      // define options (if needed)
      var options = {
        fixedContent: false,
        fixedModalPos: true,
        index: 0 // this option means you will start at first image
      }

      // Initialize the plugin
      var viewer = new PhotoViewer(items, options)
      document.querySelector('.photoviewer-modal').addEventListener(
        'click',
        function (event) {
          //  document.getElementById("output-box").innerHTML += "Sorry! <code>preventDefault()</code> won't let you check this!<br>";
          event.preventDefault()
        },
        false
      )
    },
    getdate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/MemberInfoDialog.vue